export * as Scales from './scales';
export {
  pulseRate,
  pulseRateBounds,
  respirationRate,
  respirationRateBounds,
  spo2Scale1,
  spo2Scale1Bounds,
  spo2Scale2Air,
  spo2Scale2AirBounds,
  spo2Scale2Oxygen,
  spo2Scale2OxygenBounds,
  systolicBloodPressure,
  systolicBloodPressureBounds,
  temperature,
  temperatureBounds,
} from './scales';
export {
  calculateNEWS2Score,
  calculateQuroScore,
  getOxygenSaturationScale,
} from './scoring';
export type {
  Bounds,
  Integer,
  NEWS2Bounds,
  NEWS2Result,
  NEWS2RiskBounds,
  NEWS2Scale,
  NEWS2Score,
  NEWS2VitalParameterScores,
  NEWS2VitalParameters,
  Percentage,
  QuroScore,
  QuroScoreParameters,
  QuroScoreResult,
  QuroVitalParameterScores,
  Scale,
  SingleDecimalFloat,
  VitalParameterBounds,
  VitalParameterResult,
  VitalParameterScale,
  VitalParameterScore,
  VitalParameterType,
} from './types';
export {
  Consciousness,
  NEWS2ClinicalRisk,
  OxygenSaturationScale,
} from './types';
